import { quantWsClient } from 'src/lib/newQuant';
import { container } from 'src/StaticContainer';

export const log = container.get('Logger').getSubLogger({ name: 'FilingsApi' });

export async function getFilingTypes(): Promise<string[]> {
    try {
        return await quantWsClient.getFilingTypes();
    } catch (e) {
        log.error('Failed to fetch filing types', { error: e });
        throw e;
    }
}

export async function getFilingTags(): Promise<string[]> {
    try {
        return await quantWsClient.getFilingTags();
    } catch (e) {
        log.error('Failed to fetch filing tags', { error: e });
        throw e;
    }
}

export async function getFilingSummary(filingId: string): Promise<string> {
    try {
        return (await quantWsClient.getFilingSummary(filingId)).response;
    } catch (e) {
        log.error('Failed to fetch filing summary', { error: e, filingId });
        throw e;
    }
}
